import React, { useState } from 'react'
import { updateScholarship } from '../../../store/actions/scholarshipsActions'
import { useDispatch, useSelector } from 'react-redux'
import { ERROR } from '../../../store/types'
import TextField from '../../elements/form/TextField'
import TextareaField from '../../elements/form/TextareaField'
import { Switch } from '@headlessui/react'
import NumberField from '../../elements/form/NumberField'
import RadioGroup from '../../elements/form/RadioGroup'
import { discountTypes } from './NewScholarship'
import ModalActionButton from '../../elements/ModalActionButton'

const EditScholarship = ({scholarship, close}) => {
    const [scholarshipPayload, setScholarshipPayload] = useState({
        name: scholarship.name,
        description: scholarship.description,
        discountType: scholarship.discount.type,
        discountAmount: scholarship.discount.amount,
        limited: scholarship.limits.limited,
        limitQuantity: scholarship.limits.quantity,
    })
    const [validationErrors, setValidationErrors] = useState({})
    const dispatch = useDispatch()
    const scholarshipsSelector = useSelector(state => state.scholarships)

    const validateForm = () => {
        let errors = {}
        
        if(!scholarshipPayload.name || scholarshipPayload.name === '') {
            errors.name = true
        }

        if(!scholarshipPayload.description || scholarshipPayload.description === '') {
            errors.description = true
        }

        if(!scholarshipPayload.discountType || scholarshipPayload.discountType === '') {
            errors.discountType = true
        }

        if(!scholarshipPayload.discountAmount || scholarshipPayload.discountAmount === '') {
            errors.discountAmount = true
        }

        if(scholarshipPayload.limited && (!scholarshipPayload.limitQuantity || scholarshipPayload.limitQuantity === 0)) {
            errors.limitQuantity = true
        }
        
        setValidationErrors(errors)
        console.log(errors)
        return errors
    }

    const pushScholarship = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        const payload = {
            name: scholarshipPayload.name,
            description: scholarshipPayload.description,
            limits: {
                limited: scholarshipPayload.limited,
                quantity: scholarshipPayload.limitQuantity
            },
            discount: {
                type: scholarshipPayload.discountType,
                amount: scholarshipPayload.discountAmount,
            }
        }

        dispatch(updateScholarship(scholarship._id, payload))
    }
    
    return (
        <div className='w-full'>
            <div className='w-full my-2'>
                <TextField
                    inputLabel="Term name/title" 
                    fieldId="term-name" 
                    inputType="text" 
                    requiredField={true}
                    inputPlaceholder={`The name the scholarship`}
                    preloadValue={scholarshipPayload.name || ''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setScholarshipPayload({...scholarshipPayload, ...{name: value}})}}
                />
            </div>
            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Description" 
                    fieldId="center-description"
                    inputPlaceholder={`Please add a description for the scholarship`} 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={scholarshipPayload.description || ''}
                    hasError={validationErrors && validationErrors.description} 
                    returnFieldValue={(value)=>{setScholarshipPayload({...scholarshipPayload, ...{description: value}})}}
                />
            </div>

            <div className="w-full flex justify-between gap-x-4 mt-4 border-secondary border-opacity-50">
                <div className='w-10/12'>
                    <label className="block text-[15px] font-medium font-space-grotesk">Limited Scholarship</label>
                    <label className="text-sm text-gray-600 font-sofia-pro">Flip this switch if this spaces for this scholarship are liimted.</label>
                </div>
                <div className='w-2/12 flex flex-row-reverse'>
                    <Switch
                        checked={scholarshipPayload.limited}
                        onChange={()=>{setScholarshipPayload({...scholarshipPayload, limited: !scholarshipPayload.limited})}}
                        className={`${
                            scholarshipPayload.limited ? 'bg-accent' : 'bg-gray-400'
                        } relative inline-flex items-center h-5 rounded-full w-10`}
                        >
                        <span className="sr-only">Requires fee</span>
                        <span
                            className={`transform transition ease-in-out duration-200 ${
                                scholarshipPayload.limited ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                            } inline-block w-3 h-3 transform rounded-full`}
                        />
                    </Switch>
                </div>
            </div>

            {scholarshipPayload.limited && 
                <div className='w-full my-2'>
                    <NumberField
                        inputType="number" 
                        fieldId={`limit-quantity`}
                        inputLabel="Max Quantiity of Students"
                        inputPlaceholder={`Max number of students on this scholarship`} 
                        requiredField={true}
                        preloadValue={scholarshipPayload.limitQuantity || ''}
                        hasError={validationErrors.score} 
                        returnFieldValue={(value)=>{setScholarshipPayload({...scholarshipPayload, limitQuantity: value})}}
                    />
                </div>
            }


            <h3 className='text-[15px] font-[550] font-space-grotesk mb-1 mt-4 pt-4 border-t border-gray-300'>Configure Disount</h3>
            <p className='text-sm'>Configure scholarship discount below. This determines how much this scholarship takes off any invoices that the scholarship receivers need to pay for.</p>

            <div className='my-2'>
                <RadioGroup 
                    items={discountTypes} 
                    inline={false}
                    preSelectedIndex={discountTypes.findIndex(item => item.value === scholarshipPayload.discountType)}
                    inputLabel={'Discount Type'}
                    requiredField={true}
                    returnSelected={(value) => {setScholarshipPayload({...scholarshipPayload, ...{discountType: value.value}})}} 
                    hasError={validationErrors && validationErrors.type}  
                    titleField='label'
                />
            </div>

            <div className='w-full my-2'>
                <NumberField
                    inputType="number" 
                    fieldId={`discount-amount`}
                    inputPlaceholder={`Provide amount discounted ${scholarshipPayload.discountType === 'PERCENTAGE' ? '(percentage amount)' : '(flat amount)'}`}
                    inputLabel={`Discount`} 
                    requiredField={true}
                    preloadValue={scholarshipPayload.discountAmount || ''}
                    hasError={validationErrors.discountAmount} 
                    returnFieldValue={(value)=>{setScholarshipPayload({...scholarshipPayload, discountAmount: value})}}
                />
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update scholarship`}
                    buttonAction={()=>{pushScholarship()}}
                    processing={scholarshipsSelector.updatingScholarship}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default EditScholarship